import { Component, HostListener, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NzMessageService } from 'ng-zorro-antd/message';
import { InboxService } from 'src/app/services/InboxService.service';
import { InboxFolder } from './InboxInterfaces/InboxFolder';

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'app-Inbox',
  templateUrl: './Inbox.component.html',
  styleUrls: ['./Inbox.component.less']
})
export class InboxComponent implements OnInit {
  title = 'inbox';
  folders: InboxFolder[] = [];
  folderName = '';
  newFolderName!: string;
  Nowfolder: InboxFolder = {
    Amount: 0,
    Class: '',
    Code: '0',
    Icon: 'fa-inbox',
    Name!: 'Inbox'
  };
  isCollapsed = false;
  isVisible = false;
  public innerWidth: any;
  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.innerWidth = window.innerWidth;
  }
  constructor(
    private general: InboxService,
    private route: ActivatedRoute,
    private message: NzMessageService,
    private router: Router
  ) { }

  ngOnInit() {
    this.route.queryParams.subscribe(data => {
      this.getInboxFolders();
      if (data.folder) {
        const folderNameText: string = data.folder as string;
        this.folderName = folderNameText.toLowerCase();
      }
    });
  }
  onCompose() {
    this.router.navigate(['Compose'], { relativeTo: this.route });
    if (this.innerWidth < 992) {
      this.isCollapsed = !this.isCollapsed;
    }
  }
  onNavigateFolder(folderName: string) {
    this.router.navigate(['inboxMail'], { relativeTo: this.route, queryParams: { folder: folderName }, queryParamsHandling: 'merge' });
    if (this.innerWidth < 992) {
      this.isCollapsed = !this.isCollapsed;
    }
  }
  getInboxFolders() {
    this.general.getInboxFolders().subscribe(fold => {
      this.folders = fold.rowsArray;
      if (this.folderName) {
        this.getNowFolder();
      }
    });
  }
  getNowFolder() {
    // tslint:disable-next-line: no-non-null-assertion
    this.Nowfolder = this.folders.find(x => x.Name.toLowerCase() === this.folderName)!;
  }

  showModal(): void {
    this.isVisible = true;
  }

  handleOk(): void {
    this.general.createNewFolder(this.newFolderName).subscribe(() => {
      this.getInboxFolders();
    },
      () => {
        this.getInboxFolders();
      });
    this.isVisible = false;
  }

  handleCancel(): void {
    this.isVisible = false;
  }
}
